import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import './app/core/extensions/array.extensions';
import { AppStore } from './app/core/stores/AppStore';
import * as Sentry from "@sentry/angular-ivy";
import { browserTracingIntegration, replayIntegration } from '@sentry/angular-ivy';
import { environment } from './environments/environment';

if (!location.origin.includes('localhost')) {
  const isTestEnvironment = !environment.production;

  const sentryIntegrations = [browserTracingIntegration()];

  if (!isTestEnvironment) {
    sentryIntegrations.push(replayIntegration());
  }

  // Base Sentry configuration
  const sentryConfig = {
    dsn: environment.dsn,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
    integrations: sentryIntegrations,
    tracePropagationTargets: [environment.appUrl, environment.apiUrl],
    release: environment.version.replace('v', 'ver-'),
    sendClientReports: false,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  };

  if (!isTestEnvironment) {
    sentryConfig['replaysSessionSampleRate'] = 0.1;
    sentryConfig['replaysOnErrorSampleRate'] = 1.0;
  }

  Sentry.init(sentryConfig);
}

bootstrapApplication(AppComponent, appConfig)
  .then(applicationRef => {
    AppStore.applicationRef.set(applicationRef);
  })
  .catch((err) => console.error(err));
